import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { GridFilterSelectMultiple } from './GridFilterSelectMultiple';
import { InvitationState } from '@api/models/enums/InvitationState';

interface Props {
  value?: InvitationState[];
  onChange: (value?: InvitationState[]) => void;
}

export const GridFilterInvitationState: FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation();

  const options = Object.values(InvitationState);

  return (
    <GridFilterSelectMultiple
      value={value ?? []}
      options={options}
      onChange={onChange}
      getOptionId={(option: InvitationState) => option}
      getOptionName={(option: InvitationState) =>
        t(`invitation.states.${option}`)
      }
    />
  );
};
